/* alc-formulario.js — pasos y validación del formulario de Mayoristas (Task #397).
   Mejora progresiva sobre {% form 'contact' %} de sections/alc-formulario.liquid:
   sin este archivo el form se envía en una columna con la validación nativa.
   Los patrones (correo, RFC, teléfono, URL) viven en el atributo pattern del
   Liquid; aquí solo se leen con la Constraint Validation API (validity).
   Archivo propio: no se toca theme.js (bundle de Maestrooo). */
(function () {
  var MSG = {
    email: 'Revisa el correo: parece que le falta algo (ej. compras@turestaurante.mx).',
    rfc: 'El RFC tiene 12 caracteres (empresa) o 13 (persona física), p. ej. ALC120415AB3.',
    telefono: 'Escribe 10 dígitos, p. ej. 55 9425 8871.',
    url: 'Escribe la dirección completa, p. ej. turestaurante.mx',
    aceptar: 'Necesitamos tu visto bueno para continuar.',
    falta: 'Nos falta este dato para validar tu cuenta.'
  };

  function errorOf(box) {
    var tipo = box.dataset.tipo, inputs = box.querySelectorAll('input, select, textarea');
    if (tipo === 'multiple') {
      return box.hasAttribute('data-requerido') && !box.querySelector('input:checked') ? MSG.falta : '';
    }
    var v = inputs[0] && inputs[0].validity;
    if (!v || v.valid) return '';
    if (v.valueMissing) return tipo === 'aceptar' ? MSG.aceptar : MSG.falta;
    return MSG[box.dataset.validacion] || MSG.falta;
  }

  function hasValue(box) {
    return Array.prototype.some.call(box.querySelectorAll('input, select, textarea'), function (i) {
      return i.type === 'checkbox' || i.type === 'radio' ? i.checked : i.value.trim() !== '';
    });
  }

  // Validación amable: no regaña mientras escribes; revisa al salir del campo (o al
  // elegir en chips/casillas/listas) y, si ya marcó error, lo quita en vivo.
  function paint(box) {
    var err = errorOf(box);
    box.classList.toggle('is-invalid', !!err);
    box.classList.toggle('is-valid', !err && hasValue(box));
    box.querySelector('.alc-f__err > span').textContent = err;
    box.querySelectorAll('input, select, textarea').forEach(function (i) {
      if (err) i.setAttribute('aria-invalid', 'true'); else i.removeAttribute('aria-invalid');
    });
    return err;
  }

  function init(form) {
    if (form.dataset.alcInit) return;
    form.dataset.alcInit = '1';
    form.noValidate = true;

    var grupos = Array.prototype.slice.call(form.querySelectorAll('[data-alc-paso]'));
    var porPasos = form.dataset.alcForm === 'pasos' && grupos.length > 1;
    var paso = 0;
    var resumen = form.querySelector('[data-alc-resumen]');
    var atras = form.querySelector('[data-alc-atras]');
    var enviar = form.querySelector('[data-alc-enviar]');
    var progreso;

    if (porPasos) {
      form.classList.add('is-pasos');
      progreso = document.createElement('div');
      progreso.className = 'alc-form__progress';
      var ol = document.createElement('ol');
      ol.className = 'alc-form__steps';
      ol.style.setProperty('--n', grupos.length);
      grupos.forEach(function (g) {
        var li = document.createElement('li');
        li.className = 'alc-form__step';
        li.appendChild(document.createElement('b'));
        li.appendChild(document.createTextNode(g.dataset.alcPaso));
        ol.appendChild(li);
      });
      progreso.innerHTML = '<div class="alc-form__bar"><i></i></div><div class="alc-form__count"><span></span><span></span></div>';
      progreso.insertBefore(ol, progreso.firstChild);
      form.insertBefore(progreso, form.firstElementChild);
    }

    function mostrar(n) {
      paso = n;
      if (!porPasos) return;
      grupos.forEach(function (g, i) { g.hidden = i !== n; });
      progreso.querySelectorAll('.alc-form__step').forEach(function (li, i) {
        li.classList.toggle('is-done', i < n);
        li.classList.toggle('is-current', i === n);
        if (i === n) li.setAttribute('aria-current', 'step'); else li.removeAttribute('aria-current');
        li.firstChild.textContent = i < n ? '✓' : i + 1;
      });
      progreso.querySelector('.alc-form__bar i').style.setProperty('--p', Math.round(((n + 1) / grupos.length) * 100) + '%');
      var count = progreso.querySelectorAll('.alc-form__count span');
      count[0].textContent = 'Paso ' + (n + 1) + ' de ' + grupos.length;
      count[1].textContent = Math.round((n / grupos.length) * 100) + '% completado';
      atras.hidden = n === 0;
      enviar.firstElementChild.textContent = n < grupos.length - 1 ? 'Continuar' : enviar.dataset.alcEnviar;
    }

    function ocultarResumen() { resumen.hidden = true; }

    function onChange(e, commit) {
      var box = e.target.closest && e.target.closest('.alc-f');
      if (!box) return;
      if (e.target.classList.contains('alc-f__rfc')) e.target.value = e.target.value.toUpperCase();
      if (commit || box.classList.contains('is-invalid')) paint(box);
    }

    form.addEventListener('input', function (e) {
      var t = e.target;
      onChange(e, t.type === 'radio' || t.type === 'checkbox' || t.tagName === 'SELECT');
    });
    form.addEventListener('focusout', function (e) {
      if (e.target.matches('input[type=text], input[type=email], input[type=tel], textarea')) onChange(e, true);
    });

    atras.addEventListener('click', function () {
      ocultarResumen();
      mostrar(paso - 1);
      form.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    // Se valida en el clic del botón (también lo dispara Enter en un campo), no en
    // `submit`: el script anti-bots de Shopify escucha `submit` en document en fase
    // de captura y llama form.submit() antes que este listener, así que un
    // preventDefault en `submit` ya no detenía el envío. Cancelar el clic sí.
    enviar.addEventListener('click', function (e) {
      var visibles = porPasos ? [grupos[paso]] : grupos, malos = [];
      visibles.forEach(function (g) {
        g.querySelectorAll('.alc-f').forEach(function (box) { if (paint(box)) malos.push(box); });
      });
      if (malos.length) {
        e.preventDefault();
        var label = malos[0].querySelector('.alc-f__label, .alc-check span');
        resumen.lastElementChild.textContent = malos.length === 1
          ? 'Te falta revisar 1 dato: «' + (label ? label.textContent.replace(/\s*\(opcional\)$/, '').trim() : '') + '».'
          : 'Te faltan ' + malos.length + ' datos por revisar. Los marcamos abajo.';
        resumen.hidden = false;
        var first = malos[0].querySelector('input, select, textarea');
        if (first) first.focus();
        return;
      }
      ocultarResumen();
      if (porPasos && paso < grupos.length - 1) {
        e.preventDefault();
        mostrar(paso + 1);
        form.scrollIntoView({ behavior: 'smooth', block: 'start' });
        var next = grupos[paso].querySelector('input, select, textarea');
        if (next) next.focus({ preventScroll: true });
      }
      // Último paso válido: submit nativo de {% form 'contact' %} (Shopify añade su captcha).
    });

    mostrar(0);
  }

  function scan(root) {
    root.querySelectorAll('form[data-alc-form]').forEach(init);
    var done = root.querySelector('.alc-form__done');
    if (done && /contact_posted=true/.test(location.search)) done.focus();
  }

  scan(document);
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
